// Single source of truth for desktop-app download URLs, the GitHub repo
// link, and the currently-released version (display only).
//
// URLs use GitHub's `/releases/latest/download/<asset>` redirect so the
// marketing site auto-tracks whichever non-prerelease tag is currently
// marked "Latest" on shekhu10/phantomCode. This decouples deploys from
// release cuts — bumping APP_VERSION here only updates the displayed
// label ("Download v…"), never the actual file the redirect resolves to.
//
// Asset filenames match electron-builder's `artifactName` config in
// phantomCodeDesktopapp/package.json. They are version-less so the same
// URL keeps working release-over-release. Patterns are explicit (no
// `${productName}` substitution) so spaces in the OS-displayed product
// name never leak into URLs.

import versionMetadata from "../clientVersion.json"

// Keep the download label and /api/version advertisement on the same release.
export const APP_VERSION = versionMetadata.version

export const GITHUB_REPO_URL = "https://github.com/shekhu10/phantomCode"

export const RELEASES_URL = `${GITHUB_REPO_URL}/releases`
const LATEST_DOWNLOAD_URL = `${RELEASES_URL}/latest/download`

export const DOWNLOAD_MAC_ARM64 = `${LATEST_DOWNLOAD_URL}/PhantomCodeAI-arm64.dmg`
export const DOWNLOAD_MAC_INTEL = `${LATEST_DOWNLOAD_URL}/PhantomCodeAI-x64.dmg`
export const DOWNLOAD_WINDOWS = `${LATEST_DOWNLOAD_URL}/PhantomCodeAI-Windows.exe`

// String-keyed record kept for the chatbot, which routes user intents like
// "download for mac-arm64" through a lookup table.
export const DOWNLOAD_URLS: Record<string, string> = {
  "mac-arm64": DOWNLOAD_MAC_ARM64,
  "mac-intel": DOWNLOAD_MAC_INTEL,
  windows: DOWNLOAD_WINDOWS,
}
